// extracted by mini-css-extract-plugin
export default {"transactionItem":"PBShareSettings_transactionItem__CFmpc","transactionEdit":"PBShareSettings_transactionEdit__6Z-sA"};